import { generatePath } from "react-router-dom";

import Payment from "@/api/controller/payment";
import {
  type IInitializePaymentResponse,
  IPaymentStatus,
} from "@/api/interfaces/paymentLayouts";
import type { ApiRequest, RequestResponse } from "@/api/types";
import { NavigationPath, OrderID, PaymentStatus } from "@/constants/navigation";

const generateStatusPageUrl = (barcodeWithoutChecksum: string) =>
  `${globalThis.location.origin}${generatePath(NavigationPath.OrderStatus, {
    [OrderID]: barcodeWithoutChecksum,
  })}`;

type InitializePaymentOptions = {
  barcodeWithoutChecksum: string;
  returnLabel: string;
  confirmationEmail?: string | undefined;
  customerGUID: string | undefined;
};

const initializePayment: ApiRequest<
  RequestResponse<IInitializePaymentResponse>,
  InitializePaymentOptions
> = async ({
  barcodeWithoutChecksum,
  returnLabel,
  confirmationEmail,
  customerGUID,
  ...options
}) => {
  if (!barcodeWithoutChecksum) {
    throw new Error("No cart barcode without checksum found");
  }

  return Payment.initialize({
    ...options,
    barcodeWithoutChecksum,
    body: {
      transactionBarcode: barcodeWithoutChecksum,
      options: {
        customerGUID,
        returnActionLabel: returnLabel,
        confirmationEmail,
        returnURLSuccess: `${globalThis.location.origin}${generatePath(
          NavigationPath.OrderPaymentCallback,
          {
            [OrderID]: barcodeWithoutChecksum,
            [PaymentStatus]: IPaymentStatus.SUCCESS,
          },
        )}`,
        returnURLCancelled: `${globalThis.location.origin}${generatePath(
          NavigationPath.OrderPaymentCallback,
          {
            [OrderID]: barcodeWithoutChecksum,
            [PaymentStatus]: IPaymentStatus.CANCELLED,
          },
        )}`,
        returnURLError: `${globalThis.location.origin}${generatePath(
          NavigationPath.OrderPaymentCallback,
          {
            [OrderID]: barcodeWithoutChecksum,
            [PaymentStatus]: IPaymentStatus.ERROR,
          },
        )}`,
        statusMonitorURL: generateStatusPageUrl(barcodeWithoutChecksum),
      },
    },
  });
};

const PaymentService = {
  initializePayment,
  generateStatusPageUrl,
};

export default PaymentService;
